<template>
  <div class="ps-page--signin">
    <div class="container">
      <div class="login-cart-page">
        <div class="container">
          <form @submit.prevent="submit" class="ps-form--signin">
            <loading
              :active="loading"
              :can-cancel="false"
              loader="dots"
              color="#2292ef"
              :is-full-page="true"
            ></loading>
            <div class="ps-form__header">
              <h3>{{data_.w.sign_up}}</h3>
          
              <p>{{data_.t.or_sign_up_using_your_email_address}}</p>
            </div>
            <div class="ps-form__content">
              <div class="form-group">
                <span
                  v-if="errors &&  errors.first_name"
                  class="text-danger validation-error-msg"
                >{{ errors.first_name[0] }}</span>
                <input
                  class="form-control"
                  v-model="fields.first_name"
                  type="text"
                  :placeholder="data_.t.enter_your_first_name"
                />
              </div>
              <div class="form-group">
                <span
                  v-if="errors &&  errors.first_name"
                  class="text-danger validation-error-msg"
                >{{ errors.first_name[0] }}</span>
                <input
                  class="form-control"
                  v-model="fields.last_name"
                  type="text"
                  :placeholder="data_.t.enter_your_last_name"
                />
              </div>
              <div class="form-group">
                <span
                  v-if="errors &&  errors.email"
                  class="text-danger validation-error-msg"
                >{{ errors.email[0] }}</span>
                <input
                  class="form-control"
                  v-model="fields.email"
                  type="email"
                  :placeholder="data_.t.enter_your_email_address"
                />
              </div>
              <div class="form-group">
                <span
                  v-if="errors &&  errors.mobile_number"
                  class="text-danger validation-error-msg"
                >{{ errors.mobile_number[0] }}</span>
                <tel-input v-model="fields.mobile_number"></tel-input>
                <!--<input type="text" class="form-control"-->
                <!--id="phone_number" name="phone_number"-->
                <!--v-model="fields.phone_number" placeholder="example: +xx xxx xxx xxx  ">-->
              </div>
              <div class="form-group">
                <span
                  v-if="errors &&  errors.password"
                  class="text-danger validation-error-msg"
                >{{ errors.password[0] }}</span>
                <input
                  type="password"
                  class="form-control"
                  v-model="fields.password"
                  :placeholder="data_.t.enter_your_password"
                />
              </div>
              <p>
                <i class="fa fa-shield"></i>
                {{data_.t.your_passwords_at_iqoala_are_encrypted_and_secured}}
              </p>
            </div>
            <div class="ps-form__footer">
              <button
                type="submit"
                class="ps-btn ps-btn--fullwidth ps-btn--gradient"
                style="position: relative"
              >{{data_.w.sign_up}}</button>
              <p class="remember-signin">
                Already registered?
                <a href="/login">Sign in Now!</a>
              </p>
              <p>
                {{data_.t.by_registering_you_confirm_that_you_accept_the}}
                <br />
                <a href="#">{{data_.w.terms_and_conditions}}</a>
                and
                <a href="#">{{data_.w.privacy_policy}}</a>
              </p>
            </div>
          </form>
              <div class="ps-form__method">
    
                <a class="ps-btn ps-btn--google" href="/login/google">
                  <i class="fab fa-google-plus-g"></i> With Google +
                </a>
              </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TelInput from "./../TelInput";
export default {
  components: {
    Loading,
    TelInput
  },
  props: ["data"],
  data() {
    return {
      loading: false,
      data_: null,
      errors: {},
      fields: {}
    };
  },
  mounted() {},
  created() {
    this.data_ = JSON.parse(this.data);
  },
  methods: {
    removeMessages: function() {
      this.errors = {};
    },
    submit: function() {
      this.$Progress.start();
      this.loading = true;
      // let formData = new FormData();
      // formData.append("_method", "post");
      let self = this;

      axios({
        method: "post",
        url: self.data_.url + "?_method=POST",
        data: self.fields
      })
        .then(function(response) {
          self.loading = false;

          self.$Progress.finish();
          location.replace(self.data_.redirect);
        })
        .catch(function(err) {
          self.loading = false;
          self.$Progress.fail();
          self.errors = err.response.data.errors;
        });
    }
  }
};
</script>
<style>
/* =======================
Login Register Form New Select Option
======================= */
/*.switch-register-form {
	border: 2px solid #b5b5b961;
	border-radius: 10px;
	margin-right: 24px;

}

.switch-register-form .quality {
  position: relative;
  display: inline-block;
  width: 50%;
  height: 100%;
  line-height: 40px;
}
.switch-register-form .quality:first-child label {
  border-radius: 5px 0 0 5px;
}
.switch-register-form .quality:last-child label {
  border-radius: 0 5px 5px 0;
}
.switch-register-form .quality label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  text-align: center;
  transition: transform 0.4s, color 0.4s, background-color 0.4s;
  font-family: "Source Sans Pro", sans-serif;
	font-weight: 400;
	font-size: 15px;
}
.switch-register-form .quality input[type="radio"] {
  appearance: none;
  width: 0;
  height: 0;
  opacity: 0;
}
.switch-register-form .quality input[type="radio"]:focus {
  outline: 0;
  outline-offset: 0;
}
.switch-register-form .quality input[type="radio"]:checked ~ label {
	background-color:#c8c7ceb0;
	color:#575454;
}
.switch-register-form .quality input[type="radio"]:active ~ label {
  transform: scale(1.05);
}*/
</style>
